/* eslint-disable */
<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 126.66 89.41"
  >
    <g
      id="Capa_2"
      data-name="Capa 2"
    >
      <g
        id="Layer_1"
        data-name="Layer 1"
      >
        <path
          :fill-rule="fillRule"
          :fill="colorBg"
          :class="props.fillClass"
          d="M10.41,41a10.8,10.8,0,1,1,14.88-3.44A10.8,10.8,0,0,1,10.41,41Z"
        />
        <path
          :fill-rule="fillRule"
          :fill="colorBg"
          :class="props.fillClass"
          d="M92.8,26.37a10.8,10.8,0,1,1,14.89-3.44A10.8,10.8,0,0,1,92.8,26.37Z"
        />
        <path
          :fill-rule="fillRule"
          :fill="colorBg"
          :class="props.fillClass"
          d="M49.47,20a10.8,10.8,0,1,1,14.88-3.44A10.8,10.8,0,0,1,49.47,20Z"
        />
        <path
          :fill="colorBg"
          :class="props.fillClass"
          d="M117.55,46.79V52c5.63.7,9.11,1.33,9.11,1.33S107.58,25,69.55,24.6,0,74.88,0,74.88,12.33,69,28,63V46.79H41.49V58.23q2.85-.94,5.71-1.8V46.79H80.55v3.56c1.71-.09,3.42-.15,5.12-.18V46.79Z"
        />
        <path
          :fill="colorBg"
          :class="props.fillClass"
          d="M29.91,89.41v-41H43.37v41Z"
        />
        <path
          :fill="colorBg"
          :class="props.fillClass"
          d="M49.08,89.41v-41H82.43v9.67H62.08v5.76H79.35v9.3H62.08v6.44H83.25v9.84Z"
        />
        <path
          :fill="colorBg"
          :class="props.fillClass"
          d="M87.54,89.41v-41h31.89V58.52H100.8V65.1h14.89v9.84H100.8V89.41Z"
        />
      </g>
    </g>
  </svg>
</template>

<script setup>
import { useTheme } from 'vuetify'

const props = defineProps({
  fillColor: {
    type: String,
    default: '',
  },
  fillClass: {
    type: String,
    default: '',
  },
  fillRule: {
    type: String,
    default: 'evenodd',
  },
})

const colorBg = computed(()=>props.fillColor || (useTheme().name.value === 'dark' ? '#FFF' : '#242540'),
)
</script>
